import { useForm } from 'react-hook-form';
import { audiencePlatformOptions, audienceSizeOptions } from '@interfaces/auth';
import { StepProps } from '@pages/auth/register';
import { Button } from '@vibTheme/components/_base/Button';
import { InputSelect, InputText } from '@vibTheme/components/_base/Input';

// Tudo opcional; vazio vira NULL na platform-api.
export function AudienceInfoStep({ stateStorage, publish }: StepProps) {
  const { handleSubmit, control, watch, setValue } = useForm({
    defaultValues: {
      audiencePlatform: stateStorage?.audiencePlatform ?? '',
      audiencePlatformOther: stateStorage?.audiencePlatformOther ?? '',
      audienceUsername: stateStorage?.audienceUsername ?? '',
      audienceSize: stateStorage?.audienceSize ?? '',
    },
  });

  return (
    <form
      id="register-form-audienceinfo"
      className="flex flex-col w-full text-left gap-main"
      onSubmit={handleSubmit((data) => publish({ ...stateStorage, ...data }))}
    >
      <InputSelect
        name="audiencePlatform"
        label="Onde está a sua audiência? (opcional)"
        control={control}
        options={audiencePlatformOptions}
        className="w-full"
        onChangeCallback={(event) =>
          event.target.value !== 'outro' &&
          setValue('audiencePlatformOther', '')
        }
      />
      {watch('audiencePlatform') === 'outro' && (
        <InputText
          name="audiencePlatformOther"
          control={control}
          label="Qual é o outro lugar? (opcional)"
        />
      )}
      <InputText
        name="audienceUsername"
        control={control}
        label="Nome de usuário nesse lugar (opcional)"
        placeholder="ex: @seuperfil ou nome do canal"
      />
      <InputSelect
        name="audienceSize"
        label="Tamanho da audiência (opcional)"
        control={control}
        options={audienceSizeOptions}
        className="w-full"
      />
      <Button id="register-button-submit-audienceinfo" type="submit">
        Próximo
      </Button>
    </form>
  );
}
